<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_custname,product.pr_detail "
      placeholder="输入单号、客户名称、产品名称进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/stock/cust_prod_in/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_custname}}</p>
          <p class="list-item-muted">{{item.pi_inoutno}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
    <!-- <add-button to="/stock/othin_edit" /> -->
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
// import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    // AddButton
  },
  mixins: [list],
  data() {
    return {
      params: {
        caller: 'CustProdOut'
      },
      listUrl: "/api/storage/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class = 'CUSTPRODOUT'"
            },
            {
              value: 1,
              label: "待退料",
              condition: "pi_class = 'CUSTPRODOUT' and pi_statuscode<>'AUDITED'"
            },
            {
              value: 2,
              label: "已退料",
              condition: "pi_class = 'CUSTPRODOUT' and pi_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>